import { ERROR_MESSAGES, VALIDATION_LIMITS } from '../validationConstants';

/**
 * Validation functions that return i18n keys
 * These can be called from anywhere, including form validation contexts
 * The actual translation happens at the component level
 */
export const validateRateField = (value) => {
  if (value === null || value === undefined || value === '') return ERROR_MESSAGES.REQUIRED_FIELD;
  const numValue = parseFloat(value);
  if (Number.isNaN(numValue)) return ERROR_MESSAGES.INVALID_NUMBER;
  if (numValue < VALIDATION_LIMITS.MIN_RATE || numValue > VALIDATION_LIMITS.MAX_RATE)
    return ERROR_MESSAGES.RATE_RANGE;
  return undefined;
};

export const validateMarginField = (value) => {
  if (value === null || value === undefined || value === '') return ERROR_MESSAGES.REQUIRED_FIELD;
  const numValue = parseFloat(value);
  if (Number.isNaN(numValue)) return ERROR_MESSAGES.INVALID_NUMBER;
  if (numValue < VALIDATION_LIMITS.MIN_MARGIN || numValue > VALIDATION_LIMITS.MAX_MARGIN)
    return ERROR_MESSAGES.MARGIN_RANGE;
  return undefined;
};

export const validateStipendField = (value) => {
  if (value === null || value === undefined || value === '') return ERROR_MESSAGES.REQUIRED_FIELD;
  const numValue = parseFloat(value);
  if (Number.isNaN(numValue)) return ERROR_MESSAGES.INVALID_NUMBER;
  if (numValue < VALIDATION_LIMITS.MIN_STIPEND || numValue > VALIDATION_LIMITS.MAX_STIPEND)
    return ERROR_MESSAGES.STIPEND_RANGE;
  return undefined;
};

export const validateHoursField = (value) => {
  if (value === null || value === undefined || value === '') return ERROR_MESSAGES.REQUIRED_FIELD;
  const numValue = parseFloat(value);
  if (Number.isNaN(numValue)) return ERROR_MESSAGES.INVALID_NUMBER;
  if (numValue < VALIDATION_LIMITS.MIN_HOURS) return ERROR_MESSAGES.HOURS_RANGE;
  return undefined;
};

export default {
  validateRateField,
  validateMarginField,
  validateStipendField,
  validateHoursField,
};
